import { Box, Paper, Card, CardContent, Unstable_Grid2 as Grid, Typography, Icon, CardHeader, Avatar, CardActionArea, Button } from "@mui/material";
import { DropdownModel, MasterListItem } from "../../data/interfaces/sharedmodels";
import { useEffect, useState } from "react";
import masterlistService from "../../data/api/masterlist.service";
import MasterListCommonTable from "./childcomponents/masterlistcommontable";
import { setcurrentmenu } from "../../stores/menuslice";
import { useAppDispatch } from "../../stores/hooks";


export default function MasterList() {
    const dispatch=useAppDispatch();
    const [masterLists, setMasterLists] = useState<DropdownModel[]>([]);
    const [selectedList, setSelectedList] = useState<DropdownModel | null>(null);

    useEffect(() => {
        dispatch(setcurrentmenu('masterlist'));
        masterlistService.getMasterLists().then((response) => {
            setMasterLists(response.data);
        })
    }, []);

    const handleItemClick = (
        masterList: DropdownModel|null
    ) => {
        setSelectedList(masterList);
    };
    return (
        <Box  sx={{ p: 2, minHeight: 600}}>
            {/* {selectedList?<Button color="primary" onClick={(event) => handleItemClick(null)}>Back to MasterList</Button>:null} */}
            {selectedList ?
                <MasterListCommonTable listType={selectedList} excludedCodes={[]}  asLookup={false} callback={handleItemClick}/> :
                <Box>
                    <Typography variant="h5"  sx={{ p: 1 }}>
                        Master Lists
                    </Typography>
                    <Grid container spacing={3}>
                        {masterLists.map((masterList) => {
                            return (
                                <Grid xs={4} key={masterList.Id} >

                                    <Card   >
                                        <CardContent sx={{ color: 'primary.main',p:4 }}>
                                            <Grid container alignItems='center' direction="row" justifyContent='center' >
                                                <Grid xs={4} sm={3} sx={{ display: "flex", justifyContent: 'center' }}>
                                                    <Avatar sx={{ backgroundColor: 'primary.main' }}>
                                                        <Icon fontSize="large">
                                                            list
                                                        </Icon>
                                                    </Avatar>
                                                </Grid>
                                                <Grid xs={8} sm={9}>
                                                    <Typography component="div" variant="h5">
                                                        {masterList.Description}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                        <CardActionArea sx={{ textAlign: 'center', backgroundColor: 'primary.main',cursor:'pointer' }} onClick={(event) => handleItemClick(masterList)}>
                                        <Typography variant="body1" sx={{p:.5, color:'secondary.main'}}>View</Typography> 
                                        </CardActionArea>
                                    </Card>

                                </Grid>
                            )
                        })

                        }
                    </Grid></Box>}
                    
                </Box>
    )
}